// extracted by mini-css-extract-plugin
module.exports = {"grouping":"SensorTypeChip_grouping__XzaS-","icon":"SensorTypeChip_icon__2dYVz","text":"SensorTypeChip_text__2iJAE","secondaryText":"SensorTypeChip_secondaryText__3p0h0"};